var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _rect, _rect2, _rect3, _rect4, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot18(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_50",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "#59C4FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_50",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 61,
    y: 13,
    width: 60,
    height: 39
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91 13C79.9543 13 71 21.9543 71 33V36H62C61.4477 36 61 36.4477 61 37V51C61 51.5523 61.4477 52 62 52H120C120.552 52 121 51.5523 121 51V37C121 36.4477 120.552 36 120 36H111V33C111 21.9543 102.046 13 91 13Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#90A4AE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91,
    cy: 30,
    rx: 4,
    ry: 6,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 61,
    y: 13,
    width: 60,
    height: 23,
    fill: "white",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91 14.5C90.4477 14.5 90 14.9477 90 15.5C90 16.0523 90.4477 16.5 91 16.5V14.5ZM102.694 21.6875C103.065 22.0968 103.697 22.1281 104.107 21.7573C104.516 21.3865 104.547 20.7541 104.176 20.3448L102.694 21.6875ZM106.759 24.0473C106.504 23.5579 105.899 23.3686 105.41 23.6246C104.921 23.8806 104.731 24.4848 104.987 24.9742L106.759 24.0473ZM106.425 28.9559C106.54 29.4959 107.072 29.84 107.612 29.7244C108.152 29.6088 108.496 29.0773 108.38 28.5373L106.425 28.9559ZM91 16.5C95.6375 16.5 99.8065 18.4999 102.694 21.6875L104.176 20.3448C100.926 16.7563 96.2256 14.5 91 14.5V16.5ZM104.987 24.9742C105.636 26.2139 106.124 27.5501 106.425 28.9559L108.38 28.5373C108.041 26.9518 107.49 25.4448 106.759 24.0473L104.987 24.9742Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 146V112.852C25 108.317 25.7711 103.815 27.2804 99.5389L44.7614 56.0092C47.3014 48.8126 54.1036 44 61.7353 44L118.265 44C125.896 44 132.699 48.8126 135.239 56.0092L152.72 99.5389C154.229 103.815 155 108.317 155 112.852V146C155 155.941 146.941 164 137 164H43C33.0589 164 25 155.941 25 146Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_50",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 146V112.852C25 108.317 25.7711 103.815 27.2804 99.5389L44.7614 56.0092C47.3014 48.8126 54.1036 44 61.7353 44L118.265 44C125.896 44 132.699 48.8126 135.239 56.0092L152.72 99.5389C154.229 103.815 155 108.317 155 112.852V146C155 155.941 146.941 164 137 164H43C33.0589 164 25 155.941 25 146Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#B0BEC5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 43H35V61H39V43ZM47 43H43V73V77H47H96.416C97.1876 78.7659 98.9497 80 101 80C103.761 80 106 77.7614 106 75C106 72.2386 103.761 70 101 70C98.9497 70 97.1876 71.2341 96.416 73H47V43Z",
    fill: "black",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146 77.584C147.766 76.8124 149 75.0503 149 73C149 70.2386 146.761 68 144 68C141.239 68 139 70.2386 139 73C139 75.0503 140.234 76.8124 142 77.584V103V107H146H165V103H146V77.584Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138 89H134V111V115H138H165V111H138V89Z",
    fill: "black",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51 146.584C49.2341 145.812 48 144.05 48 142C48 139.239 50.2386 137 53 137C55.7614 137 58 139.239 58 142C58 144.05 56.7659 145.812 55 146.584V172V176H51H32V172H51V146.584Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 134,
    width: 6,
    height: 14,
    rx: 2,
    fill: "black",
    fillOpacity: 0.6
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 62,
    cy: 106,
    r: 6,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 118,
    cy: 106,
    r: 6,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot18);
export default __webpack_public_path__ + "static/media/bot-18.e9cf313c07628bb249743598f3fe14cc.svg";
export { ForwardRef as ReactComponent };